export const getApp = (state) => {
  return state.appReducer;
};

export const getShowHeader = (state) => {
  const { showHeader } = getApp(state);
  return showHeader;
};
